export default "__VITE_ASSET__DCIGp7kU__"